import useDiscard from "../../useDiscard";
import useMap from "../../utils/useMap";
import useLayerIdentity, { isLayer } from "./validator/useLayerIdentity";


const layer1Caching = useMap();

export const useQueryLayer1 = layer2 => {
    if (isLayer(layer2)) {
        return layer1Caching.get(layer2) || layer2;
    }
    return layer2;
}

export const setLayer = (layer1, layer2) => {
    layer1Caching.set(layer2, layer1);
    useDiscard(layer1, () => layer1Caching.delete(layer2))
}
